import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = "919949126046";
export const COMPANY_PHONE = "+91 9949126046";
export const COMPANY_EMAIL = "loanhub929@gmail.com";
export const COMPANY_ADDRESS = "Serving Across Telangana";
export const COMPANY_ADDRESS_LEGAL = "Siddipet, Telangana, India";

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lj_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Just clear stale credentials — let React/ProtectedRoute re-render and redirect
      // via <Navigate/>. Avoid a hard window.location redirect that fights with SPA state.
      localStorage.removeItem("lj_token");
      localStorage.removeItem("lj_user");
    }
    return Promise.reject(err);
  }
);

export const LOAN_PRODUCTS = [
  { slug: "personal-loan", key: "personal_loan", label: "Personal Loan",
    tagline: "Instant funds for life's moments — weddings, travel, medical.",
    rate: "As per Bank/NBFC Eligibility", min: 50000, max: 4000000, tenure: "12–60 months" },
  { slug: "business-loan", key: "business_loan", label: "Business Loan",
    tagline: "Fuel growth. Working capital, expansion & inventory.",
    rate: "As per Bank/NBFC Eligibility", min: 100000, max: 20000000, tenure: "12–84 months" },
  { slug: "home-loan", key: "home_loan", label: "Home Loan",
    tagline: "Your dream home across Telangana — competitive terms.",
    rate: "As per Bank/NBFC Eligibility", min: 500000, max: 100000000, tenure: "5–30 years" },
  { slug: "mortgage-loan", key: "mortgage_loan", label: "Mortgage Loan",
    tagline: "Unlock the value of your property.",
    rate: "As per Bank/NBFC Eligibility", min: 500000, max: 50000000, tenure: "5–20 years" },
  { slug: "loan-against-property", key: "loan_against_property", label: "Loan Against Property",
    tagline: "High-value funds against residential or commercial property.",
    rate: "As per Bank/NBFC Eligibility", min: 1000000, max: 75000000, tenure: "5–15 years" },
  { slug: "new-car-loan", key: "new_car_loan", label: "New Car Loan",
    tagline: "Drive home the latest model with quick approval.",
    rate: "As per Bank/NBFC Eligibility", min: 100000, max: 15000000, tenure: "12–84 months" },
  { slug: "used-car-loan", key: "used_car_loan", label: "Used Car Loan",
    tagline: "Financing for pre-owned cars with fair valuation.",
    rate: "As per Bank/NBFC Eligibility", min: 100000, max: 5000000, tenure: "12–60 months" },
  { slug: "commercial-vehicle-loan", key: "commercial_vehicle_loan", label: "Commercial Vehicle Loan",
    tagline: "Trucks, buses & LCVs — grow your fleet.",
    rate: "As per Bank/NBFC Eligibility", min: 500000, max: 50000000, tenure: "12–84 months" },
  { slug: "msme-loan", key: "msme_loan", label: "MSME Loan",
    tagline: "Government-backed schemes for small businesses.",
    rate: "As per Bank/NBFC Eligibility", min: 100000, max: 20000000, tenure: "12–60 months" },
];

export const LOAN_TYPE_LABEL = LOAN_PRODUCTS.reduce((acc, p) => {
  acc[p.key] = p.label;
  return acc;
}, {});

export const inr = (n) => {
  if (n == null || isNaN(n)) return "—";
  return "₹" + Math.round(Number(n)).toLocaleString("en-IN");
};

export const shortINR = (n) => {
  if (n == null || isNaN(n)) return "—";
  const v = Number(n);
  if (v >= 10000000) return "₹" + (v / 10000000).toFixed(2) + " Cr";
  if (v >= 100000) return "₹" + (v / 100000).toFixed(2) + " L";
  if (v >= 1000) return "₹" + (v / 1000).toFixed(1) + "K";
  return "₹" + v;
};
